import React from 'react';

import icon from  '../../../assets/emptyIcon.png';

const EmptyIcon = ({ size, className }) => <img src={icon} style={{ width: size+'px' }} className={className} alt="Icone de Vazio"/>;

export default EmptyIcon;
